import {
  Box, Button, Grid, TextField, Typography, makeStyles,
} from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../contexts/StoryContext';
import MessageBox from './MessageBox';
import SubquestionBox from './SubquestionBox';

function PrintToPDF() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  const [value, setValue] = React.useState('');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <>
      <Box displayPrint="none" display="block">
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >

            <Grid item xs={12}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                Print to PDF
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item xs={10} sm={6}>
                  <MessageBox>
                    {/* <Typography variant="h5" gutterBottom>Print to PDF</Typography> */}
                    <Typography variant="body1" gutterBottom>
                      Now that you&apos;ve seen the data, you can help to inform and educate others on child care in states and communities by creating a PDF with the filters you have applied. Take your custom PDF to an upcoming meeting or email it to others, including legislators. Every voice counts, and children and families are counting on you! You may customize the PDF to include your contact information and area of interest in your community. Add any custom text in the highlighted box below.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Please Note: To ensure that your PDF looks as expected, please select your browser setting to print &quot;background graphics/images and colors&quot; after you press the button to print to PDF.
                    </Typography>

                    <TextField
                      id="outlined-full-width"
                      placeholder="Additional text"
                      helperText="Enter text here to be printed in PDF"
                      fullWidth
                      multiline
                      rows={4}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{ style: { backgroundColor: '#fff' } }}
                      variant="outlined"
                      value={value}
                      onChange={handleChange}
                    />
                    <Button color="primary" variant="contained" onClick={() => { window.print(); return false; }}>Print to PDF</Button>
                  </MessageBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </SubquestionBox>
      </Box>

      {value && (
        <Box displayPrint="block" display="none">
          <SubquestionBox color={lightColor}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>

                  <Typography variant="body1" gutterBottom>
                    {value}
                  </Typography>
                  <Typography variant="body2">
                    Please Note: The information in this section was added by the user and is not necessarily endorsed by Child Care Aware® of America.
                  </Typography>
                </MessageBox>
              </Grid>
            </Grid>
          </SubquestionBox>
        </Box>
      )}

    </>
  );
}

export default PrintToPDF;
